module.exports = __webpack_public_path__ + "img/ic_share-white.a5e59d2c.svg";